import { useEffect } from "react";
import { useState } from "react";
import { ReactElement } from "react";

export function Select(props: {
  header: { displayValue: string; enabled: boolean };
  options: { value: string; displayValue: string }[] | undefined;
  value: string | undefined;
  width: string;
  visible: boolean;
  onChange: (value: string) => void;
}): ReactElement {
  const { header, options, value, width, visible, onChange } = props;
  const [selectedValue, setSelectedValue] = useState<string>("");

  useEffect(() => {
    setSelectedValue(value === undefined ? "" : value);
  }, [value]);

  const optionElements = [
    <option
      key=""
      value=""
      disabled={!header.enabled}
      className="text-gray-400"
    >
      {header.displayValue}
    </option>,
  ];

  if (options !== undefined) {
    optionElements.push(
      ...options.map((o) => (
        <option value={o.value} key={o.value} className="text-gray-600">
          {o.displayValue}
        </option>
      ))
    );
  }

  return (
    <select
      className={`${width} border-2 border-gray-200 focus:border-blue-400 focus:ring-0 ${
        selectedValue === "" ? "text-gray-400" : "text-gray-600"
      } ${visible ? "visible" : "invisible"}`}
      value={selectedValue}
      onChange={(e) => {
        setSelectedValue(e.target.value);
        onChange(e.target.value);
      }}
    >
      {optionElements}
    </select>
  );
}
